import moment from 'moment-timezone';

import { CalendarEvent } from '../data-utils';
import { dstManager } from './dst-manager';
import { trafficVariablesConfig } from '../traffic-variables-config';

const normalizeEventData = (event: CalendarEvent, timezone: string): CalendarEvent => {
	if (!trafficVariablesConfig.enableHandleDST) return event;

	const dateKeys: (keyof CalendarEvent)[] = ['start', 'end', 'originalStart', 'originalEnd'];

	return {
		...event,
		...dateKeys.reduce((datesHash, key) => {
			datesHash[key] = dstManager.adjustDateForServer(moment(event[key] as string | Date), timezone);
			return datesHash;
		}, {})
	};
};

export const eventDataManager = {
	normalizeEventData
};
